<template>
  <div>
    <v-row>
      <v-col cols="10">
        <div v-show="$vuetify.breakpoint.mdAndUp">
          <v-btn
            text
            color="success"
            small
            @click="$ui.openDialog('add_urls')">
            <v-icon left>mdi-plus</v-icon>
            {{ $t('actions.add') }}
          </v-btn>
          <v-btn
            text
            color="error"
            small
            :disabled="selected.length === 0"
            @click="$ui.openDialog('remove_urls', { ids: selected })">
            <v-icon left>mdi-delete</v-icon>
            {{ $t('actions.remove') }} ({{ selected.length }})
          </v-btn>
          <v-btn
            text
            color="warning"
            small
            @click="$ui.openDialog('refresh_urls', { ids: selected })">
            <v-icon left>mdi-refresh</v-icon>
            <span v-if="selected.length === 0">{{ $t('actions.refresh-all') }}</span>
            <span v-else>{{ $t('actions.refresh') }} ({{ selected.length }})</span>
          </v-btn>
        </div>
        <div v-show="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly">
          <v-btn icon color="success" @click="$ui.openDialog('add_urls')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn icon color="error" :disabled="selected.length === 0"
                 @click="$ui.openDialog('remove_urls', { ids: selected })">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn icon color="warning"
                 @click="$ui.openDialog('refresh_urls', { ids: selected })">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="2" class="text-right" style="display: none;">
        <v-btn icon>
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-col>
      <v-col v-show="false" cols="4" class="text-right">
        <!--
        Comparé au
        <v-btn text small :color="$moment(date).hour() === 0 ? '' : 'success'">
          <v-icon left v-if="$moment(date).hour() === 0">mdi-calendar-clock</v-icon>
          <v-icon left v-else>mdi-account-clock</v-icon>
          <span v-if="$moment(date).hour() !== 0">{{ $moment(date).format('lll') }}</span>
          <span v-else>{{ $moment(date).format('ll') }}</span>
        </v-btn>
        -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'PageButtons',
  props: ['date', 'selected', 'order']
}
</script>

<style scoped>

</style>